// extracted by mini-css-extract-plugin
module.exports = {"Select":"CustomSelect_Select__PIl0I","SelectPlaceholder":"CustomSelect_SelectPlaceholder__11BLI"};